module.exports = __webpack_public_path__ + "static/media/29BDOS14.9bee02b6.jpg";